// extracted by mini-css-extract-plugin
module.exports = {"codeBox":"CodeBox_codeBox__3VbbT","code":"CodeBox_code__1PvqS","copyButton":"CodeBox_copyButton__2aFqC"};